import React from 'react';
import Helmet from 'react-helmet';

export enum TwitterCards {
  SummaryLargeImage = 'summary_large_image',
  Summary = 'summary',
}

const DEFAULT_TITLE = 'The Information';
const DEFAULT_IMAGE_URL =
  'https://dmxvlyap9srmn.cloudfront.net/production/articles/129/large_large_large_theinformation.png';

interface MetaTagsProps {
  title?: string;
  description?: string;
  ogImagePath?: string;
  ogDescription?: string;
  ogTitle?: string;
  twitterDescription?: string;
  twitterTitle?: string;
  twitterCard?: TwitterCards;
  ogSiteName?: string;
}

const MetaTags = ({
  title = DEFAULT_TITLE,
  description,
  ogImagePath,
  ogDescription = description,
  ogTitle = title,
  ogSiteName = title,
  twitterDescription = description,
  twitterTitle = title,
  twitterCard = TwitterCards.SummaryLargeImage,
}: MetaTagsProps) => {
  const baseImageUrl = `${window.location.protocol}//${window.location.host}`;
  const ogImageUrl = ogImagePath ? `${baseImageUrl}${ogImagePath}` : DEFAULT_IMAGE_URL;

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta property="og:title" content={ogTitle} />
      <meta property="og:description" content={ogDescription} />
      <meta property="og:site_name" content={ogSiteName} />
      <meta property="og:image" content={ogImageUrl} />
      <meta name="twitter:card" content={twitterCard} />
      <meta name="twitter:title" content={twitterTitle} />
      <meta name="twitter:description" content={twitterDescription} />
    </Helmet>
  );
};

export default MetaTags;
